module.exports = __webpack_public_path__ + "static/media/shareYourJourneyImage.a50f408f.jpg";